import * as log from 'loglevel';
import {game} from "../../GameCore";
import {userWantsToCrouch} from "../../input/Interaction";
import {gameConfig} from "../../config/GameConfig";
import {gameState} from "../../config/GameState";
import {levelGroup} from "../../level/Level";
import {showSecondaryScreen, showPrimaryScreen} from '../../../screens/ScreenManager';
import {playSound} from '../../audio/AudioManager';
import {resetObstacles} from '../../level/ground/Obstacles';
import {addJumpParticles, addLandParticles} from '../../particles/ParticleManager';
import {stopCountdownTimer} from '../../timer/GameTimer';
import {stopStageTimer} from '../../level/stages/StageManager';
import {getGameManager} from '../../GameManager';

export var playerSprite: Phaser.Sprite;
export var playerAnimSprite: Phaser.Sprite;
export var isCrouching: boolean;
export var isJumping: boolean;
export var isPoweredUp: boolean;
export var wasTouchingFloor: boolean;

var velocityY: number,
    overrideFrame: boolean,
    signSprite: Phaser.Sprite,
    isCentred: boolean,
    justLanded: boolean,
    obstacleTimeout: number,
    signTweens: Phaser.Tween[];



export function createPlayer()
{
    //  add the player sprite to the scene

    playerSprite = game.add.sprite(gameConfig.player.targetX, game.world.height - 250);

    var frame: Phaser.Frame = game.cache.getFrameData("zingy").getFrameByName("roll-1");

    //  create the sign sprite

    signSprite = game.add.sprite(0, 0, 'sign');

    //  position behind zingy

    signSprite.x = frame.width * 0.75;
    signSprite.y = 30;
    signSprite.anchor = new Phaser.Point(0.5, 1);
    signSprite.scale.setTo(0.01, 0.01);
    signSprite.alpha = 0;
    signSprite.angle = -45;

    playerSprite.addChildAt(signSprite, 0);
    
    
    //  add an animatable player sprite
    
    playerAnimSprite = game.add.sprite(0, 0, 'zingy', 'roll/001');
    playerSprite.addChild(playerAnimSprite);

    //  enable physics and add basic physics props

    game.physics.arcade.enable(playerSprite);

    //  set player physics props


    playerSprite.body.bounce = 0.5;
    playerSprite.debug = true;
    //playerSprite.body.maxSpeed = 70;
    playerSprite.body.velocity.x = 1;
    playerSprite.body.velocity.y = 1;
    playerSprite.body.acceleration = new Phaser.Point(50, 50);
    //playerSprite.body.gravity.y = 900;

    playerSprite.body.setSize(80, 80, 15, 5);

    playerAnimSprite.animations.add('roll', Phaser.Animation.generateFrameNames('roll/', 1, 20, '', 3), 20, true, false);
    playerAnimSprite.animations.add('crouch', Phaser.Animation.generateFrameNames('crouch/', 1, 16, '', 3), 20, false, false);
    playerAnimSprite.animations.add('jump', Phaser.Animation.generateFrameNames('jump/', 1, 13, '', 3), 50, false, false);
    playerAnimSprite.animations.add('look-at-camera', Phaser.Animation.generateFrameNames('look-at-camera/', 1, 10, '', 3), 20, false, false);
    playerAnimSprite.animations.add('look-ahead', Phaser.Animation.generateFrameNames('look-ahead/', 1, 10, '', 3), 20, false, false);
    playerAnimSprite.animations.add('stumble', Phaser.Animation.generateFrameNames('stumble/', 1, 16, '', 3), 20, false, false);

    //  play rolling animation by default

    playerAnimSprite.animations.play('roll');

    //  add the player sprite to the level

    levelGroup.addChild(playerSprite);

    justLanded = false;
}


/**
 * update the player on each tick
 */
export function updatePlayer()
{
    var isTouchingFloor: boolean,
        isTouchingCeiling: boolean,
        _velocityY: number;

    //  update x velocity

    playerSprite.body.velocity.x = gameState.player.speed * 50 * gameState.player.multiplier * gameState.player.powerupMultiplier;

    if(playerSprite.body.x < -50)
    {
        if (getGameManager().gameOverMessage()) return;

        getGameManager().gameOverMessage('You lost control!');

        slowToStandstill();

        stopCountdownTimer();

        stopStageTimer();

        return;
    }


    //  set new player velocities

    _velocityY = playerSprite.body.velocity.y;

    if (! isNaN(_velocityY)) velocityY = _velocityY;

    //  is the player touching the floor?

    isTouchingFloor = playerSprite.body.touching.down;
    isTouchingCeiling = playerSprite.body.touching.up;

    //  when the player hits the ceiling, bounce off

    if (isTouchingCeiling)
    {
        isJumping = false;
        isCrouching = false;

        playerSprite.body.velocity.y = 2;
    }

    //  if the player is touching the floor, allow them to crouch

    if (isTouchingFloor)
    {
        if (isJumping)
        {
            addLandParticles(playerSprite.body.x + playerSprite.body.width * 0.5, playerSprite.body.y + playerSprite.body.height);
        }

        //  no longer jumping

        isJumping = false;



        //justLanded = false;

       //  if the player is holding space and the sprite is touching the floor, let's crouch

       if (userWantsToCrouch())
       {
           isCrouching = true;

           if ( ! overrideFrame && gameState.player.isControllable) playerAnimSprite.animations.play('crouch');
       }
    }
    else
    {
        playerSprite.body.velocity.y = (playerSprite.body.velocity.y || 0) + 50;
    }

    //  if the player is crouching, but has released the space bar, jump!

    if (gameState.player.isControllable && isTouchingFloor && isCrouching && ! userWantsToCrouch())
    {
        //  flag that we're jumping, and can no longer crouch until we hit the floor again

        isJumping = true;
        isCrouching = false;

        //  set animation frame

        if ( ! overrideFrame) playerAnimSprite.animations.play('jump');

        //  push the player up into the air

        playerSprite.body.velocity.y = gameConfig.player.jumpSpeed;

        //  play a button sound

        playSound('jump');

        //  add some dust particles

        addJumpParticles(playerSprite.body.x + playerSprite.body.width * 0.25, playerSprite.body.y + playerSprite.body.height);
    }

    //  check current player state

    if (isCrouching || isJumping)
    {
        //  boost the player's speed if we're either crouching or jumping

        game.add.tween(gameState.player).to({ speed: gameConfig.player.boostSpeed }, 250, null, true);
    }
    else
    {
        //  otherwise tween back to the base state

        game.add.tween(gameState.player).to({ speed: gameConfig.player.baseSpeed }, 500, null, true);

        //  set animation frame

        if ( ! overrideFrame) playerAnimSprite.animations.play('roll');
    }

    //  save player y velocity in a stupid hack

    //_velocityY = playerSprite.body.velocity.y;
    //
    //if (! isNaN(_velocityY)) velocityY = _velocityY;

    if (gameState.player.isControllable) checkPlayerX();
}


/**
 * check the player's x position
 */
function checkPlayerX()
{
    //  find the distance between the player and the ideal player position
    //  and adjust the player's speed accordingly

    playerSprite.body.velocity.x += (gameConfig.player.targetX - playerSprite.body.x) * 0.5;
}


/**
 * reset the player's position and properties
 */
export function resetPlayer()
{
    //  reset current speed

    gameState.player.speed = gameConfig.player.baseSpeed;
    gameState.player.isControllable = true;

    //  reset state
    
    isCrouching = false;
    isJumping = false;

    //  reset player sprite position

    playerSprite.reset(gameConfig.player.targetX, game.world.height - 250);
}


/**
 * the player has hit an obstacle
 */
export function performObstacleHit()
{
    //  set a "bump" frame, disable controls for a second and bump the player backwards

    overrideFrame = true;
    gameState.player.isControllable = false;

    //playerSprite.frameName = 'bump';

    //  reduce player's speed

    gameState.player.speed = Math.max(gameState.player.speed - 10, -5);

    obstacleTimeout = setTimeout(() =>
    {
        overrideFrame = false;

        gameState.player.isControllable = true;

        playerAnimSprite.animations.play('roll');
    }, 1000);
}


/**
 * slow the player to a standstill
 */
export function slowToStandstill()
{
    var tween: Phaser.Tween;

    //  stop the player from controlling zingy's speed

    gameState.player.isControllable = false;

    //TODO  play sign animation

    log.debug('slowing to standstill');


    //  bring zingy to a stop

     tween = game.add.tween(gameState.player).to({ speed: 0 }, 2000, null, true);

     //  and when he's stopped, show the question popup

     tween.onComplete.add(() =>
     {
         //  pause the game

         game.paused = true;

         log.debug('sjowing game over screen');

         //  show the question popup

         showSecondaryScreen('game-over');
     });
}


/**
 * show zingy's sign
 */
export function showSign()
{
    //  move zingy into the middle of the screen

    clearTimeout(obstacleTimeout);

    //game.add.tween(gameConfig.player).to( { targetX: game.world.width * 0.5 }, 2000, Phaser.Easing.Circular.InOut, true);
    game.add.tween(playerSprite.body).to( { x: 500 }, 2000, Phaser.Easing.Quadratic.InOut, true);

    //  play sound

    playSound('level-complete');

    //  get zingy's basic frame

    setTimeout(() =>
    {
        signTweens =
            [

                game.add.tween(signSprite).to( { angle: 10, alpha: 1 }, 1000, Phaser.Easing.Back.Out, true),
                game.add.tween(signSprite.scale).to( { x: 1, y: 1 }, 500, Phaser.Easing.Back.Out, true)
            ];

        //  play zingy's sign audio

        playSound('zingy-sign');

        //  look at the camera

        overrideFrame = true;

        playerAnimSprite.animations.play('look-at-camera');

    }, 2000);
}


/**
 * hide zingy's sign
 */
export function hideSign()
{
    signTweens =
        [
            game.add.tween(signSprite).to( { angle: -45, alpha: 0 }, 1000, Phaser.Easing.Exponential.Out, true),
            game.add.tween(signSprite.scale).to( { x: 0.01, y: 0.01 }, 500, Phaser.Easing.Circular.In, true)
        ];


    //  remove all obstacles from the game

    resetObstacles();

    //  look ahead

    playerAnimSprite.animations.play('look-ahead');

    overrideFrame = false;

    //  increase the speed by increments every time we start a new level

    gameState.player.multiplier += gameState.player.multiplierIncrements;
}


/**
 * interrupt a sign animation and hide it immediately
 */
export function hideSignInstantly()
{
    if (signTweens)
    {
        signTweens[0].stop();
        signTweens[1].stop();
    }

    signSprite.angle = -45;
    signSprite.alpha = 0;
    signSprite.scale.x = 0.01;
    signSprite.scale.y = 0.01;
}



// WEBPACK FOOTER //
// ./src/ts/game/sprites/player/Player.ts